
import EazyHeading from '@/components/EazyHeading.vue';
import InvisibleRecaptcha from 'vue-invisible-recaptcha';
import router from '@/router';
import newsletter from '@/logic/services/newsletter';
import BlueCheckbox from '@/components/BlueCheckbox.vue';

export default {
  name: 'AppBell',

  components: {
    EazyHeading,
    InvisibleRecaptcha,
    BlueCheckbox,
  },

  data(): Record<string, unknown> {
    return {
      router,
      email: '',
      emailSuccessfullyCreated: false,
      emailHasBeenAlreadySent: false,
      emailError: false,
      isEmailValid: true,
      regulationsAccepted: false,
      newsletterAcceptted: false,
      submissionAttempted: false,
      submittingEmail: false,
      renderRecaptcha: false,
    };
  },

  computed: {
    userRole(): string | null {
      return localStorage.getItem('userRole');
    },

    prodEnv(): boolean {
      return window.location.href.includes('app.');
    },
  },

  mounted(): void {
    setTimeout(() => {
      this.renderRecaptcha = true;
    }, 1000);
  },

  methods: {
    resetEmailErrors(): void {
      this.emailHasBeenAlreadySent = false;
      this.emailError = false;
      this.isEmailValid = true;
      this.emailSuccessfullyCreated = false;
    },

    doesEmailMatchRgx(): boolean {
      const re = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      return re.test(String(this.email).toLowerCase());
    },

    validateEmail(): void {
      this.submissionAttempted = true;
      this.resetEmailErrors();

      this.isEmailValid = this.doesEmailMatchRgx();
    },

    async makeEmailPost(e: { preventDefault: () => void }): Promise<void> {
      if (!this.prodEnv) e.preventDefault();
      this.submittingEmail = true;
      if (!this.prodEnv) this.validateEmail();

      if (!this.isEmailValid || !this.regulationsAccepted || !this.newsletterAcceptted) {
        this.submittingEmail = false;
        return;
      }

      let response = await newsletter.postSubscription(this.email);

      if (response.ok) {
        this.emailSuccessfullyCreated = true;
      } else {
        const data = await response.json();
        this.resetEmailErrors();
        if (data.detail === 'email: This value is already used.') {
          this.emailHasBeenAlreadySent = true;
        } else {
          this.emailError = true;
        }
      }

      this.submittingEmail = false;
    },
  },
};
